import React from "react";
import OtherHero from "../../../Components/Breadcrumb/OtherHero/OtherHero";
import {
  servicesRightHover,
  supplyBg,
  handtools,
  gloves,
  pumps,
} from "../../../assets/images";
import { useTranslation } from "react-i18next";

const IndustrialSupply = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const newsItems = [
    {
      id: 1,
      imgSrc: pumps,
      title: "Pumps, compressors",
      path: "pumps-compressor",
    },
    {
      id: 2,
      imgSrc: gloves,
      title: "PPE Equipment",
      path: "gloves",
    },
    {
      id: 3,
      imgSrc: handtools,
      title: "Hand tools, measuring instruments",
      path: "hand-tools",
    },
  ];

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${supplyBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <OtherHero
          title="Supply"
          content="Efficient and reliable supply solutions for critical industries"
        />
      </div>
      <div className="bg-[#EDEDED] py-10 md:py-20 ">
        <div className="max-w-containerSm md:max-w-container mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
          {newsItems.map((item) => (
            <a
              key={item.id}
              href={`/${currentLanguage}/industrial/supply/${item.path}`}
            >
              <div className="relative md:w-[583px] h-[372px] md:h-[440px] group overflow-hidden rounded-lg">
                {/* Image */}
                <img
                  src={item.imgSrc}
                  className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
                  alt=""
                />

                {/* Title overlay with blur background */}
                <div className="absolute bottom-0 w-full flex items-center justify-between h-[72px] md:h-[84px] py-3 px-9 bg-black/50 backdrop-blur-md text-white text-[18px] md:text-[20px] font-medium">
                  <p>{t(item.title)}</p>
                  <img className="w-6 h-6" src={servicesRightHover}></img>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
};

export default IndustrialSupply;
